import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const CustomizedSwal = withReactContent(Swal);

export const onDisplayAlert = ({ title, description, html, type, preConfirm }) =>
  CustomizedSwal.fire({
    title: <strong>{title}</strong>,
    html: html || description,
    icon: type,
    preConfirm,
  });
